import { render, staticRenderFns } from "./ProgressSpinner.vue?vue&type=template&id=0465d5b2"
import script from "./ProgressSpinner.vue?vue&type=script&lang=ts"
export * from "./ProgressSpinner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports